module.exports = __webpack_public_path__ + "img/fish-cooked.07a1a051.svg";